import React, {Component} from 'react';
import {Button, Container, Form, FormGroup, Input, Label} from 'reactstrap';
import {FormattedMessage, injectIntl} from "react-intl";
import {toast} from "react-toastify";
import ContentLoader from "../../components/ContentLoader";
import Slider from "react-slick";
import Picture from '../../components/Picture'
import {formatPhone} from '../../helpers/format'
import MetaTags from '../../components/SEO/MetaTags'
import {handlePublicRequestError, handleRequestError, Request} from '../../helpers/request'
import {businessUnitOptions} from '../../helpers/select'
import {getVariable} from '../../helpers/variable'
import LocalisationSelect from '../../components/form/LocalisationSelect'
import LocaleLink, {addLocalePrefix} from '../../components/Routes/LocaleLink'
import Faq from "../../components/Faq/Faq";
import {faqCardsHeader, faqCardsBody} from "../../components/Faq/Pages/RecruitPage";


class RecruitPage extends Component {
    state = {
        firstname: '',
        lastname: '',
        phone: '',
        email: '',
        company: '',
        city: '',
        business_unit: null,
        job_title: '',
        conditions_accepted: false,
        loading: false,
        variables: null,
        quotes: null,
        region: false
    };

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        Request.get('variables/by-category/recruitment')
            .then((data) => {
                this.setState({variables: data})
            })
            .catch(handleRequestError);

        Request.get('study_cases')
            .then((data) => {
                this.setState({quotes: data});
            })
            .catch(handlePublicRequestError);
    }

    submit(e) {

        e.preventDefault();

        const {
            firstname,
            lastname,
            phone,
            email,
            company,
            city,
            job_title,
            business_unit,
            region
        } = this.state;

        const {intl} = this.props;
        this.setState({loading: true});

        Request.post('recruitment/submit', {
            firstname,
            lastname,
            phone,
            email,
            company,
            city,
            job_title,
            business_unit,
            region: null
        })
            .then(() => {
                toast.success(
                    intl.formatMessage({
                        id: "portfolio.form_contact.message_sent",
                        defaultMessage: "Votre message a bien été envoyé."
                    })
                );

                this.props.history.push(addLocalePrefix('/'));
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({loading: false});
            });
    }

    toggleConditionsAccepted() {
        this.setState({conditions_accepted: !this.state.conditions_accepted});
    }

    settings = {
        dots: false,
        autoplay: true,
        autoplaySpeed: 7000,
        speed: 1000,
        infinite: true,
        fade: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: false
    };

    render() {
        return (
            <div className="recruit-page">
                {this.renderContent()}
            </div>
        )
    }

    renderContent = () => {
        const {intl} = this.props;
        if (!this.state.variables || !this.state.quotes) return <ContentLoader/>;

        return (
            <>
                <section className="sec-recruit">

                    <MetaTags page="recruit"/>

                    <Container>
                        <div className="recruit-head">
                            <h1 className="line-heading">
                                {getVariable(this.state.variables, 'recruitment.title')}
                            </h1>
                        </div>

                        <div className="recruit-wrap">
                            <div className="recruiters">
                                <div className="recruit-img">
                                    <Picture
                                        src={require("../../../images/team-vous-recrutez.png")}
                                        webp={require("../../../images/team-vous-recrutez.webp")}/>
                                </div>
                            </div>
                            <div className="recruit-bloc recruit-bloc-right">
                                <div>
                                    <p className="strong">
                                        <FormattedMessage
                                            id="portfolio.recruit.bloc_1.title"
                                            defaultMessage="Urban Linker a développé une plateforme de recrutement spécialisée dans les métiers du digital."
                                        />
                                    </p>

                                    <p>
                                        <FormattedMessage
                                            id="portfolio.recruit.bloc_1.paragraph_1"
                                            defaultMessage="Faites le choix de l’expertise et d’un accompagnement sur-mesure en optant pour les meilleurs chasseurs de talents : nous vous mettons en contact avec les profils les plus adaptés aux offres d’emploi proposées par votre entreprise."
                                        />
                                    </p>

                                    <p>
                                        <FormattedMessage
                                            id="portfolio.recruit.bloc_1.paragraph_2"
                                            defaultMessage="Urban Linker a développé une plateforme de recrutement spécialisée dans les métiers du digital. Faites le choix de l’expertise et d’un accompagnement sur-mesure en optant pour les meilleurs chasseurs de talents : nous vous mettons en contact avec les profils les plus adaptés aux offres d’emploi proposées par votre entreprise."
                                        />
                                    </p>

                                    <a href="#contact-recruit" className="btn btn-warning">
                                        <FormattedMessage
                                            id="portfolio.recruit.bloc_1.contact_button"
                                            defaultMessage="Contactez-nous"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Container>

                    <Container className="recruit-container">
                        <div className="container-title">
                            <h2>
                                {getVariable(this.state.variables, 'recruitment.subtitle')}
                            </h2>
                        </div>
                        <div className="recruit-wrap align-end">
                            <div className="recruiters">
                                <div className="recruit-bloc recruit-bloc-left">
                                    <div className="recruit-text" style={{marginBottom: "1rem"}}>
                                        <h3>
                                            {getVariable(this.state.variables, 'recruitment.list.1.title')}
                                        </h3>
                                        <p className="strong">
                                            {getVariable(this.state.variables, 'recruitment.list.1.text')}
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <FormattedMessage
                                                id="portfolio.recruit.bloc_2.paragraph_1"
                                                defaultMessage="Nous sélectionnons des candidatures en fonction des postes recherchés et adaptés aux valeurs de votre entreprise. Notre objectif : accompagner vos recrutements de manière fluide et adaptée."
                                            />
                                        </p>

                                        <p>
                                            <FormattedMessage
                                                id="portfolio.recruit.bloc_2.paragraph_2"
                                                defaultMessage="Les profils que nous vous proposons ont été sélectionnés selon des critères précis : niveau de compétences, missions recherchées, expérience dans le secteur du web, formations, soft skills et personnalité… Tant d’éléments nous permettant de trouver le meilleur candidat."
                                            />
                                        </p>

                                        <p>
                                            <FormattedMessage
                                                id="portfolio.recruit.bloc_2.paragraph_3"
                                                defaultMessage="En tant qu’employeur vous avez accès, sur notre plateforme en ligne, à un espace personnel sur lequel vous pouvez accéder aux différentes candidatures, gérer vos entretiens et debriefs et surtout accéder à un pool de talents en recherche active sur le marché."
                                            />
                                        </p>

                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="doll"/>
                                <div className="team-info-block">
                                    <div className="member-info">
                                        <div className="hexagon">
                                            <span>9</span>
                                        </div>
                                        <ul>
                                            <li><h3>Digital Headhunter</h3></li>
                                        </ul>

                                        <div className="progress-wrap">
                                            <div className="progress-line">&nbsp;</div>
                                        </div>
                                    </div>
                                    <div className="shape-angle shape1">
                                        <span className="text-thin">Geek</span>
                                        <span className="member-quility">Atout</span>
                                    </div>
                                    <div className="shape-angle shape2">
                                        <span className="text-thin">Son avantage</span>
                                        <span className="member-quility">
                                        Expertise marché
                                    </span>
                                    </div>
                                    <div className="shape-angle shape3">
                                        <span className="text-thin">Mad skills</span>
                                        <span className="member-quility">Techniques de chasse</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Container>
                </section>

                <section className="dashboard">
                    <div className="container">
                        <div className="dashboard-wrap combine-best">
                            <div className="dashboard-img">
                                <div className={"mockups-image recruit-best-image"}>
                                    <Picture
                                        src={require("../../../images/recruit-best.png")}
                                        webp={require("../../../images/recruit-best.webp")}/>
                                </div>
                            </div>
                            <div className="dashboard-text">
                                <h3>
                                    {getVariable(this.state.variables, 'recruitment.list.2.title')}
                                </h3>
                                <div className="topic-list"
                                     dangerouslySetInnerHTML={{__html: getVariable(this.state.variables, 'recruitment.list.2.text')}}/>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="dashboard">
                    <div className="container recruit-bloc recruit-personal-dashboard">

                        <div className="dashboard-wrap">
                            <div className="dashboard-text">
                                <div className="container-title">
                                    <h2>
                                        <FormattedMessage
                                            id="portfolio.recruit.feature.title"
                                            defaultMessage="Parmi nos Fonctionnalités"
                                        />
                                    </h2>
                                    <p>
                                        <FormattedMessage
                                            id="portfolio.recruit.feature.sub_title"
                                            defaultMessage="Afin de faciliter vos recherches et votre choix, notre plateforme de recrutement vous offre un accès à un espace recruteur complété par de nombreuse fonctionnalité"
                                        />
                                    </p>
                                </div>
                                <h3>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.dashboard.title"
                                        defaultMessage="Un dashboard personnel"
                                    />

                                </h3>
                                <p className="strong">
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.dashboard.subtitle"
                                        defaultMessage="Sur votre espace employeur, profitez d’un dashboard avec une vue globale de vos recherches et recrutements en cours"
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.dashboard.paragraph_1"
                                        defaultMessage="Simple d’utilisation et parfaitement adapté à l’utilisateur (notre UX/UI a bien travaillé), vous pouvez accéder directement aux nouveaux candidats, aux candidats en process avec les prochaines étapes, ainsi qu’aux candidats en recherche active d’une nouvelle opportunité, que nous avons pré-selectionné comme étant top profil."
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.dashboard.paragraph_2"
                                        defaultMessage="L’interface a été pensée pour être intuitive, pratique et permet une vue d’ensemble sur le déroulé de vos recrutements."
                                    />
                                </p>
                            </div>

                            <div className="dashboard-img">
                                <div className={"mockups-image recruit-personal-dashboard-image"}>
                                    <Picture
                                        src={require("../../../images/recruit-personal-dashboard.png")}
                                        webp={require("../../../images/recruit-personal-dashboard.webp")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="dashboard">
                    <div className="container recruit-bloc recruit-direct-access">
                        <div className="dashboard-wrap">
                            <div className="dashboard-img">
                                <div className={"mockups-image recruit-direct-access-image"}>
                                    <Picture
                                        src={require("../../../images/recruit-direct-access.png")}
                                        webp={require("../../../images/recruit-direct-access.webp")}/>
                                </div>
                            </div>

                            <div className="dashboard-text" style={{marginTop: "0px"}}>
                                <h3>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.direct_access.title"
                                        defaultMessage="Un accès direct aux talents proposés par Urban Linker"
                                    />
                                </h3>
                                <p className="strong">
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.direct_access.subtitle"
                                        defaultMessage="Parmi les talents proposés par nos headhunters, vous pouvez sélectionner les dossiers de candidature des top profils qui vous intéressent et les ajouter à votre wishlist."
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.direct_access.paragraph_1"
                                        defaultMessage="Simple d’utilisation et parfaitement adapté à l’utilisateur (notre UX/UI a bien travaillé), vous pouvez accéder directement aux nouveaux candidats, aux candidats en process avec les prochaines étapes, ainsi qu’aux candidats en recherche active d’une nouvelle opportunité, que nous avons pré-selectionné comme étant top profil."
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.direct_access.paragraph_2"
                                        defaultMessage="L’interface a été pensée pour être intuitive, pratique et permet une vue d’ensemble sur le déroulé de vos recrutements."
                                    />
                                </p>
                                <div className="topic-list">
                                    <ul>
                                        <li>
                                            <FormattedMessage
                                                id="portfolio.recruit.feature.direct_access.list_1"
                                                defaultMessage="Par type de profils"
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="portfolio.recruit.feature.direct_access.list_2"
                                                defaultMessage="Par mots clés : intitulé du poste, compétences phares, etc."
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="portfolio.recruit.feature.direct_access.list_3"
                                                defaultMessage="Par mots clés : intitulé du poste, compétences phares, etc."
                                            />
                                        </li>
                                        <li>
                                            <FormattedMessage
                                                id="portfolio.recruit.feature.direct_access.list_4"
                                                defaultMessage="Par localisation et possibilité de télétravail..."
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="dashboard">
                    <div className="container recruit-bloc recruit-manage-jobs">
                        <div className="dashboard-wrap">
                            <div className="dashboard-text">
                                <h3>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.job_tracking.title"
                                        defaultMessage="Ajoutez et suivez vos missions !"
                                    />

                                </h3>
                                <p className="strong">
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.job_tracking.subtitle"
                                        defaultMessage="Vous pouvez demander  facilement de lancer une nouvelle mission sur la plateforme, il vous suffit d'indiquer le type de profil, la localisation, la rémunération et le type de contrat."
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.job_tracking.paragraph_1"
                                        defaultMessage="Pratique et intuitive, cette partie de la plateforme vous offre une vue d’ensemble sur les actions en cours en rapport avec la mission : le nombre de candidatures envoyées, les candidats en processus de recrutement, les candidats refusés…"
                                    />
                                </p>
                                <p>
                                    <FormattedMessage
                                        id="portfolio.recruit.feature.job_tracking.paragraph_2"
                                        defaultMessage="Urban Linker vous permet également d’affiner les résultats grâce à des critères de recherche complets. "
                                    />
                                </p>
                            </div>

                            <div className="dashboard-img">
                                <div className={"mockups-image recruit-manage-jobs-image"}>
                                    <Picture
                                        src={require("../../../images/recruit-manage-jobs.png")}
                                        webp={require("../../../images/recruit-manage-jobs.webp")}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="section-form" id={'contact-recruit'}>
                    <div className="container">
                        <Form onSubmit={(e) => this.submit(e)}>
                            <h1 className="line-heading">
                                <FormattedMessage
                                    id="portfolio.recruit.need.title"
                                    defaultMessage="Vous cherchez à recruter ?"
                                />
                            </h1>
                            <div className="fields-row">
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.firstname.label"
                                            defaultMessage="Prénom*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.firstname.placeholder",
                                                defaultMessage: "Pierre"
                                            })
                                        }
                                        value={this.state.firstname}
                                        onChange={(e) => this.setState({firstname: e.target.value})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.lastname.label"
                                            defaultMessage="Nom*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.lastname.placeholder",
                                                defaultMessage: "Durand"
                                            })
                                        }
                                        value={this.state.lastname}
                                        onChange={(e) => this.setState({lastname: e.target.value})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.phone.label"
                                            defaultMessage="Téléphone*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="tel"
                                        pattern="([+]?[0-9]+)?"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.phone.placeholder",
                                                defaultMessage: "Format : (+33)0123456789"
                                            })
                                        }
                                        value={this.state.phone}
                                        onChange={(e) => this.setState({phone: formatPhone(e)})}
                                    />
                                </FormGroup>
                            </div>
                            <div className="fields-row">
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.email.label"
                                            defaultMessage="Email*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="email"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.email.placeholder",
                                                defaultMessage: "Pour vous écrire"
                                            })
                                        }
                                        value={this.state.email}
                                        onChange={(e) => this.setState({email: e.target.value})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.company.label"
                                            defaultMessage="Entreprise*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.company.placeholder",
                                                defaultMessage: "Votre entreprise"
                                            })
                                        }
                                        value={this.state.company}
                                        onChange={(e) => this.setState({company: e.target.value})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.city.label"
                                            defaultMessage="Ville*"
                                        />
                                    </Label>
                                    <LocalisationSelect
                                        required
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.city.placeholder",
                                                defaultMessage: "Votre ville"
                                            })
                                        }
                                        value={this.state.city}
                                        onChange={city => this.setState({city})}
                                    />
                                </FormGroup>
                            </div>
                            <div className="row">

                                <div className="field-list-row">
                                    {this.renderBusinessUnits()}
                                </div>

                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.recruit.position.label"
                                            defaultMessage="Poste souhaité*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.recruit.position.placeholder",
                                                defaultMessage: "Indiquez l'intitulé du poste"
                                            })
                                        }
                                        value={this.state.job_title}
                                        onChange={(e) => this.setState({job_title: e.target.value})}
                                    />
                                </FormGroup>

                            </div>

                            <div className="btn-wrap checkbox-wrap">
                                <div className="custom-control checkbox-wrap mb-5 warning">
                                    <Input
                                        required
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="posibility"
                                        onChange={() => this.toggleConditionsAccepted()}
                                    />
                                    <Label className="custom-control-label" htmlFor="posibility">
                                        <span className="box-block mr-3"/>
                                        <span className="check-text">
                                            <FormattedMessage
                                                id="portfolio.form.cgu"
                                                defaultMessage="En cochant la case, vous confirmez avoir lu et accepté les conditions d'utilisation de vos données listées {link}."
                                                values={{
                                                    link: (
                                                        <LocaleLink to={'/cgu'} className={'link-cgu'} target='_blank'>
                                                            <FormattedMessage
                                                                id="myurban.header.notifications.new_application_to_job_order.here"
                                                                defaultMessage={'ici'}
                                                            />
                                                        </LocaleLink>
                                                    )
                                                }}
                                            />
                                        </span>
                                    </Label>
                                </div>
                                <Button
                                    className="btn btn-warning"
                                    disabled={this.state.loading}
                                >
                                    <FormattedMessage
                                        id="portfolio.recruit.button"
                                        defaultMessage="ENVOYER"
                                    />
                                </Button>
                            </div>
                        </Form>
                    </div>
                </section>

                <section className="section-faq">
                    <div className="faq recruit-faq">
                        <div className="container">
                            <div className="faq-header recruit-faq-header">
                                <h2 className="page-header">
                                    <FormattedMessage
                                        id="faq.jobs.title"
                                        defaultMessage="Nous répondons à vos questions"/>
                                </h2>
                                <p>
                                    <FormattedMessage
                                        id="faq.recruit.subtitle1"
                                        defaultMessage="Quel est l’intérêt d’une plateforme de recrutement telle que Urban Linker ? Comment fonctionne la plateforme en ligne ?"
                                    /><br/>
                                    <FormattedMessage
                                        id="faq.recruit.subtitle2"
                                        defaultMessage="Découvrez toutes les réponses à vos questions."
                                    />
                                </p>
                            </div>
                            <Faq
                                cardsBody={faqCardsBody}
                                cardsHeader={faqCardsHeader}
                                cardsLength="2"
                            />
                        </div>
                    </div>
                </section>

                <section className="sec-quote">
                    <div className="container">
                        <div className="quote-wrap">
                            <div className="quote-head">
                                <h2>
                                    {getVariable(this.state.variables, 'recruitment.study_case.title')}
                                </h2>
                                <p>
                                    {getVariable(this.state.variables, 'recruitment.study_case.text')}
                                </p>
                                <LocaleLink to="/case-study" className="btn btn-line-primary">
                                    {getVariable(this.state.variables, 'recruitment.study_case.button')}
                                </LocaleLink>
                            </div>

                            {this.renderQuotes()}

                        </div>
                    </div>
                </section>
            </>
        )
    };

    acronymize = (author) => {
        let matches = author.match(/\b(\w)/g);

        return matches.join('. ');
    };

    renderQuotes() {
        const {quotes} = this.state;
        if (quotes.length === 0) return null;

        return (
            <Slider className={"quote-block"} {...this.settings}>
                {
                    quotes.map((quote, key, array) => {
                        return (
                            <div key={key}>
                                <blockquote className="quote">
                                    {quote.testimony_content}
                                    <span className="quote-sign">
                                        <span className="text-sign">{this.acronymize(quote.testimony_author)}</span>
                                        <span className='quote-title'>{quote.company_name}</span>
                                    </span>
                                </blockquote>
                                {array[key + 1] ?
                                    <blockquote className="quote" key={array[key + 1]}>
                                        {array[key + 1].testimony_content}
                                        <span className="quote-sign">
                                                <span
                                                    className="text-sign">{this.acronymize(array[key + 1].testimony_author)}</span>
                                                <span className='quote-title'>{array[key + 1].company_name}</span>
                                            </span>
                                    </blockquote>
                                    : null}
                            </div>
                        )
                    })
                }
            </Slider>
        )
    }

    renderBusinessUnits() {
        return (
            <div className="check-list w-100">
                <Label>
                    <FormattedMessage
                        id="portfolio.recruit.business_unit.label"
                        defaultMessage="Quel type de profil recrutez-vous ?*"
                    />
                </Label>
                <ul>
                    {
                        businessUnitOptions.map((business_unit, key) => {
                            return this.renderBusinessUnit(key, business_unit);
                        })
                    }
                </ul>
            </div>
        )
    }

    renderBusinessUnit(key, business_unit) {
        return (
            <li key={key}>
                <Label className="checkbox-warning-round">
                    <Input
                        required
                        type="radio"
                        name="radio-btn"
                        onChange={() => this.setState({business_unit: business_unit.value})}
                    />
                    <span>{business_unit.label}</span>
                </Label>
            </li>
        )
    }
}

export default injectIntl(RecruitPage);
